import React from 'react';
import './style.sass';
import { Filters, CardsActivity } from './components';
import { ScrollWrapper } from '../../../ui-kit';
import { Provider } from './context/Provider';
import { FiltersNav } from './components/filters/components';

/**
 *
 * @param onLoadStatistics{function}
 * @param onExportButtonClick{function}
 * @param view{string}
 * @returns {JSX.Element}
 * @constructor
 */

const Activity = ({
  onLoadStatistics, onExportButtonClick, view,
}) => (
  <div className="activity-container">
    <ScrollWrapper>
      <Provider>
        {view !== 'dailyLogs' ?
          <Filters
            activeView={view}
            onLoadStatistics={onLoadStatistics}
            onExportButtonClick={onExportButtonClick}
          /> :
          <FiltersNav
            activeView={view}
          />
        }
        <CardsActivity />
      </Provider>
    </ScrollWrapper>
  </div>
);

export default Activity;
